// Generated by LiveScript 1.6.0
var each, context, core, computed, watchers, registerDirective, components, registry, domQuery, fnHelper, createInstance, _default;
each = require('./fn').each;
context = require('./context');
core = require('./core');
computed = require('./computed');
watchers = require('./watchers');
registerDirective = require('./directives').registerDirective;
components = require('./components');
registry = require('./registry');
domQuery = require('./dom-query');
fnHelper = function(f){
  return computed.mark(function(){
    return f;
  });
};
createInstance = function(){
  var ctx, readyHandler;
  ctx = context.make();
  core.bootstrap(ctx);
  readyHandler = null;
  return {
    init: function(){
      var selectors, res$, i$, ref$, len$, n;
      if (ctx.data == null) {
        ctx.data = core.reactive(ctx, {}, '', null, null);
      }
      components.registerTemplates();
      domQuery.setupObserver(ctx);
      res$ = [];
      for (i$ = 0, len$ = (ref$ = Array.from(ctx.directives.keys())).length; i$ < len$; ++i$) {
        n = ref$[i$];
        res$.push("[" + ctx.prefix + n + "]");
      }
      selectors = res$;
      if (selectors.length > 0) {
        each(function(it){
          return registry.scanAndRegister(ctx.registry, it, ctx);
        })(
        Array.from(document.querySelectorAll(selectors.join(','))));
      }
      if (readyHandler == null) {
        readyHandler = function(){
          if (document.readyState === 'interactive') {
            return components.registerTemplates();
          }
        };
        document.addEventListener('readystatechange', readyHandler);
      }
      return ctx.data;
    },
    computed: computed.mark,
    watch: function(key, fn){
      return watchers.watch(ctx, key, fn);
    },
    unwatch: function(key, fn){
      return watchers.unwatch(ctx, key, fn);
    },
    directive: function(name, cb, isParametric){
      return registerDirective(ctx, name, cb, isParametric || false);
    },
    prefix: function(value){
      var v;
      v = value || 'o';
      return ctx.prefix = v.endsWith('-')
        ? v
        : v + "-";
    },
    cache: function(){},
    batch: function(fn){
      return core.batch(ctx, fn);
    },
    fn: fnHelper,
    nextTick: function(){
      return Promise.resolve();
    },
    load: function(files){
      if (!Array.isArray(files)) {
        files = [files];
      }
      return Promise.all(files.map(components.loadTemplateFile));
    },
    register: function(root){
      var el;
      switch (false) {
      case typeof root !== 'string':
        el = document.createElement('div');
        el.innerHTML = root;
        return components.registerTemplates(el);
      default:
        return components.registerTemplates(root || void 8);
      }
    },
    destroy: function(){
      var x$, that;
      ctx.destroyed = true;
      if (readyHandler != null) {
        document.removeEventListener('readystatechange', readyHandler);
        readyHandler = null;
      }
      x$ = ctx;
      x$.watchers.clear();
      x$.deps.depMap.clear();
      x$.deps.versions.clear();
      x$.registry.clear();
      if ((that = ctx.observer) != null) {
        that.disconnect();
        ctx.observer = null;
      }
      return ctx.data = null;
    }
  };
};
_default = createInstance();
module.exports = {
  createInstance: createInstance,
  'default': _default,
  computed: computed.mark,
  fn: fnHelper
};